import React from "react";
import { useNavigate } from "react-router-dom";
import Seo from "../components/Generic/Seo";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <>
      <Seo
        data={{
          title: "Page Not Found | WISE",
          description: "The page you are looking for does not exist.",
          keywords: "404, page not found, wise",
          pathSlug: "404",
        }}
      />
      <div
        style={{
          minHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <h1
          className="text-secondary"
          style={{ fontSize: "6rem", marginBottom: "1rem" }}
        >
          404
        </h1>
        <h2 className="text-secondary" style={{ marginBottom: "1rem" }}>
          Oops! Page not found
        </h2>
        <p
          className="text-secondary"
          style={{ marginBottom: "2rem", maxWidth: "500px" }}
        >
          The page you are trying to access does not exist or has been moved.
        </p>
        <button className="btn btn-primary" onClick={() => navigate("/")}>
          Go Back Home
        </button>
      </div>
    </>
  );
};

export default NotFound;
